export const navigation = [
    {
      link: "/",
      name: "Inicio",
      target: "home",
    },
    {
      link: "/",
      name: "Nosotros",
      target: "SobreNosotros",
    },
    {
      link: "/",
      name: "App",
      target: "TuViajeApp",
    },
    {
      link: "/destinos",
      name: "Destinos",
    },
    {
      link: "/turismos",
      name: "Paquetes",
    },
  ];
  